import { useMemo } from 'react';

import { GroupedOptions, UseOptionsQueryParams, UseOptionsQueryReturnType } from '../types';

export const getUseOptionsQuery =
  (groups: GroupedOptions[]) =>
  ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType => {
    const filteredGroups = useMemo(() => {
      return groups
        .map((group) => {
          const filteredOptions = searchText
            ? group.options.filter((option) =>
                option.label.toLowerCase().includes(searchText.toLowerCase()),
              )
            : group.options;
          return {
            ...group,
            options: filteredOptions,
          };
        })
        .filter((g) => g.options.length > 0);
    }, [searchText]);

    return {
      groups: filteredGroups,
      fetching: false,
    };
  };
